import { render, staticRenderFns } from "./logs-view.vue?vue&type=template&id=4aa4e9bf"
import script from "./logs-view.vue?vue&type=script&lang=js"
export * from "./logs-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports